import { useState, createContext, useMemo } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState({ type: 'candidate' });

    const handleUserType = (identity) => {
        identity === 0 ? setUser({ type: 'candidate' }) : setUser({ type: 'agency' });
    };

    const isCandidateState = useMemo(() => {
        return user.type === 'candidate';
    }, [user]);

    return (
        <UserContext.Provider value={{ isCandidateState, user, setUser, handleUserType }}>
            {children}
        </UserContext.Provider>
    );
};
